import { useEffect, useState } from 'react';
import './DonateHighlight.css';

const SHINE_SESSION_KEY = "pangolino_donate_shine_shown";

interface DonateHighlightProps {
  children: React.ReactNode;
}

export function DonateHighlight({ children }: DonateHighlightProps): JSX.Element {
  const [showShine, setShowShine] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem(SHINE_SESSION_KEY)) {
      setShowShine(true);
      sessionStorage.setItem(SHINE_SESSION_KEY, "true");
    }
  }, []);

  return (
    <span className="DonateHighlight">
      <span className={"DonateHighlight-Inner" + (showShine ? " DonateHighlight-Shine" : "")}>
        {children}
      </span>
    </span>
  )
}
